// extracted by mini-css-extract-plugin
export default {"overlay":"AdditionalSeat_overlay__WqkOa","leg":"AdditionalSeat_leg__dMha-","icon":"AdditionalSeat_icon__8CmM5"};